module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent2"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm03_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("International Standard Book Number"), _c('br'), _vm._v("0-292-78425-2 (paper)"), _c('br'), _vm._v("Library of Congress Catalog Card Number 60-14312"), _c('br'), _vm._v("Copyright © 1961 by the University of Texas Press"), _c('br'), _vm._v("All rights reserved"), _c('br'), _vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Thirteenth paperback printing, 2002")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("Requests for permission to reproduce material from this work should be sent to Permissions, University of Texas Press, Box 7819, Austin, Texas 78713-7819.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f00iv-01.jpg"
    }
  }), _vm._v(" The paper used in this publication meets the minimum requirements of American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, ANSI Z39.48-1984.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e17ba4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03_copy.vue
// module id = 66
// module chunks = 0